import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "../components/ui/dialog";
import { toast } from "sonner";
import { Plus, FileText, Download, Trash2 } from "lucide-react";

export default function PayslipsPage() {
  const [items, setItems] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ employee_id: "", month: new Date().toISOString().slice(0,7), file_base64: "", filename: "" });

  const load = async () => {
    setItems((await api.get("/payslips")).data);
    setEmployees((await api.get("/employees")).data);
  };
  useEffect(() => { load(); }, []);

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => setForm({ ...form, file_base64: reader.result, filename: f.name });
    reader.readAsDataURL(f);
  };

  const save = async () => {
    if (!form.employee_id || !form.file_base64) { toast.error("Seleziona dipendente e carica PDF"); return; }
    try {
      await api.post("/payslips", form);
      toast.success("Cedolino caricato");
      setForm({ employee_id: "", month: new Date().toISOString().slice(0,7), file_base64: "", filename: "" });
      setOpen(false); load();
    } catch (e) { toast.error("Errore"); }
  };

  const download = (p) => {
    const a = document.createElement("a");
    a.href = p.file_base64;
    a.download = p.filename || `cedolino_${p.month}.pdf`;
    a.click();
  };

  const del = async (id) => {
    if (!window.confirm("Eliminare il cedolino?")) return;
    await api.delete(`/payslips/${id}`);
    toast.success("Eliminato"); load();
  };

  const empName = (id) => {
    const e = employees.find((x) => x.id === id);
    return e ? `${e.name} ${e.lastname}` : "—";
  };

  return (
    <div className="p-4 md:p-12" data-testid="payslips-page">
      <div className="flex items-start justify-between mb-8">
        <div>
          <div className="text-xs uppercase tracking-widest text-[#757575] mb-2">Cedolini</div>
          <h1 className="font-display text-4xl">Cedolini paga</h1>
          <p className="text-[#555] mt-1 text-sm">Upload mensile PDF · disponibile al dipendente · archiviato in sicurezza</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button data-testid="new-payslip-btn" className="rounded-full bg-[#FF7A29] hover:bg-[#E85D00] h-11 btn-glow">
              <Plus className="w-4 h-4 mr-2"/> Carica cedolino
            </Button>
          </DialogTrigger>
          <DialogContent className="rounded-3xl border-0 max-w-md">
            <DialogHeader><DialogTitle className="font-display text-2xl">Carica cedolino</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div>
                <Label>Dipendente *</Label>
                <Select value={form.employee_id} onValueChange={(v)=>setForm({...form, employee_id: v})}>
                  <SelectTrigger className="rounded-xl mt-1"><SelectValue placeholder="Seleziona"/></SelectTrigger>
                  <SelectContent>
                    {employees.map((e) => <SelectItem key={e.id} value={e.id}>{e.name} {e.lastname}</SelectItem>)}
                  </SelectContent>
                </Select>
              </div>
              <div><Label>Mese</Label><Input type="month" className="rounded-xl mt-1" value={form.month} onChange={(e)=>setForm({...form, month: e.target.value})}/></div>
              <div>
                <Label>File PDF *</Label>
                <Input type="file" accept="application/pdf" onChange={onFile} className="rounded-xl mt-1"/>
                {form.filename && <div className="text-xs text-[#FF7A29] mt-1">✓ {form.filename}</div>}
              </div>
            </div>
            <DialogFooter><Button onClick={save} data-testid="payslip-save" className="rounded-full bg-[#FF7A29] hover:bg-[#E85D00]">Carica</Button></DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid md:grid-cols-3 gap-5">
        {items.length === 0 && <div className="col-span-3 card-smart p-12 text-center text-[#757575]"><FileText className="w-10 h-10 mx-auto mb-3 text-[#FF7A29]/50"/>Nessun cedolino caricato.</div>}
        {items.map((p) => (
          <div key={p.id} className="card-smart p-6 flex items-start gap-4" data-testid={`payslip-${p.id}`}>
            <div className="w-12 h-12 rounded-xl bg-[#FFF0E3] text-[#FF7A29] flex items-center justify-center shrink-0">
              <FileText className="w-6 h-6"/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-display text-lg">{empName(p.employee_id)}</div>
              <div className="text-xs text-[#757575] mb-3">{new Date(p.month + "-01").toLocaleDateString("it-IT", {month:"long", year:"numeric"})}</div>
              <div className="flex gap-2">
                <Button size="sm" onClick={()=>download(p)} data-testid={`download-${p.id}`} className="rounded-full bg-[#FF7A29] hover:bg-[#E85D00] h-8 text-xs"><Download className="w-3 h-3 mr-1"/>Scarica</Button>
                <Button size="sm" variant="ghost" onClick={()=>del(p.id)} className="rounded-full h-8 text-xs hover:bg-red-50 hover:text-red-600"><Trash2 className="w-3 h-3"/></Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
